<div class="loading-screen-wrapper" *ngIf="tourStart"></div>
<navbar></navbar>

<div class="mainContainer">
    <!-- TODO: disable breadcrume first -->
    <sidebar id="main-side-menu">
    </sidebar>
    <div class="contentContainer" [style.width]="getCollapseMenu() ? 'calc(100% - 180px)' : 'calc(100% - 65px)'">
        <div class="loader" *ngIf="loading"></div>
        <router-outlet></router-outlet>

    </div>
</div>